import { Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom';
import HomePage from './components/Homepage';
import AutomotivePage from './components/AutomotivePage';
import Page from './components/page/Page';
import ProductPage from './components/Productpage';
import ResourcesPage from './components/Resourcespage';
import SustainabilityPage from './components/Sustainabilitypage';
import SingleProductPage from './components/productPage/singleProductPageComponents/SingleProductPage';
import InvestorRelationsPage from './components/InvestorRelationsPage';
import ContactUsPage from './components/ContactUsPage';
import SimulationPage from './components/resourcesPage/simulationPage/SimulationPage';
import BrowseAllProductPage from './components/browseAllProductPage/BrowseAllProductPage';
import DistributorPortalPage from './components/distributorPortalPage/DistributorPortalPage';
import NoResultPage from './components/noResultPage/NoResultPage';
import Page404 from './components/noResultPage/Page404';
import Page500 from './components/noResultPage/Page500';
import TelecomunicationPage from './components/telecomunicationPage/TelecomunicationPage';
import AerospacePage from './components/aerospacePage/AerospacePage';
import IndustrialPage from './components/industrialPage/IndustrialPage';
import ComputingPage from './components/computingPage/ComputingPage';
import ConsumerPage from './components/comsumerPage/ConsumerPage';
import ResourcePage from './components/resourcesPage/ResourcePage';
import GenericResourcePage from './components/resourcesPage/GenericResourcePage';
import YageoGroupPage from './components/yageoGroupPage/YageoGroupPage';
import NewsRoom from './components/NewsRoom';
import CareerPage from './components/careerPage/CareerPage';
import DesignRegistration from './components/resourcesPage/DesignRegistration';
import YageoGroupViedo from './components/yageoGroupPage/YageoGroupViedo';
import YageoGroupPresentation from './components/yageoGroupPage/YageoGroupPresentation';
import FITCalculatorPage from './components/resourcesPage/simulationPage/FITCalculatorPage';
import ElectronicApplicationPage from './components/Ynex/ElectronicApplication/ElectronicApplicationPage';
import HVACPage from './components/Ynex/HVACApplication/HVACPage';
import SensorAcademyPage from './components/SensorAcademyPage';
const ProductRedirect = () => {
    const { partNumber } = useParams();
    return <Navigate to={`/products/Capacitors/part/${partNumber}`} replace />;
};
const SearchRedirect = () => {
    const params = new URLSearchParams(window.location.search);
    const query = params.get('q');
    return <Navigate to={`/products/Capacitors?search=${query}`} replace />;
};
const SearchRedirectFiles = () => {
    const params = window.location.href.split('/');
    console.log(params);
    const query = params[params.length - 1];
    return <Navigate to={`/browse/products?search=${query}`} replace />;
};

function App() {
    return (
        <Routes>
            <Route path={'/'} element={<HomePage />} />
            <Route path={'/applications/automotive/*'} element={<AutomotivePage />} />
            <Route path={'/applications/industrial/*'} element={<IndustrialPage />} />
            <Route
                path={'/applications/computing-enterprisesystems/*'}
                element={<ComputingPage />}
            />
            <Route path={'/applications/consumer/*'} element={<ConsumerPage />} />
            <Route
                path={'/products/:category/:subCategory?/part/:partNumber'}
                element={<SingleProductPage />}
            />
            <Route path={'/products/*'} element={<ProductPage />} />
            <Route path={'/About/Sustainability/*'} element={<SustainabilityPage />} />
            <Route path={'/About/NewsRoom'} element={<NewsRoom />} />
            <Route path={'/SalesResources/ResourceLibrary'} element={<ResourcesPage />} />
            <Route
                path={'/SalesResources/ResourceLibrary/:itemType/:id/:lang?'}
                element={<ResourcePage />}
            />
            {/* GenericResourcePage with additional GraphQL roundtrip to determine the actual item type */}
            <Route
                path={'/SalesResources/ResourceLibrary/item/:id/:lang?'}
                element={<GenericResourcePage />}
            />
            <Route
                path={'/SalesResources/DesignRegistrationProductListing'}
                element={<DesignRegistration />}
            />
            <Route path={'/page/:lang/:id/*'} element={<Page />} />
            <Route path={'/About/InvestorRelations/*'} element={<InvestorRelationsPage />} />
            <Route path={'/SalesResources/ContactUs'} element={<ContactUsPage />} />
            <Route path={'/SalesResources/Distributors'} element={<ContactUsPage />} />
            <Route path={'/SalesResources/Representatives'} element={<ContactUsPage />} />
            <Route path={'/SalesResources/SalesOffices'} element={<ContactUsPage />} />
            <Route path={'/SalesResources/SensorAcademy'} element={<SensorAcademyPage />} />
            <Route path={'/SalesResources/SimulationTools/*'} element={<SimulationPage />} />
            <Route
                path={'/SalesResources/SimulationTools/FailureInTimeCalculator'}
                element={<FITCalculatorPage />}
            />
            <Route path={'/About/YAGEOGroupOverview/*'} element={<YageoGroupPage />} />
            <Route
                path={'/About/YAGEOGroupOverview/presentation'}
                element={<YageoGroupPresentation />}
            />
            <Route path={'/About/YAGEOGroupOverview/video'} element={<YageoGroupViedo />} />
            <Route path={'/browse/products/*'} element={<BrowseAllProductPage />} />
            <Route
                path={'/SalesResources/DistributorPortals'}
                element={<DistributorPortalPage />}
            />
            <Route path={'/no_results'} element={<NoResultPage />} />
            <Route path={'/404_error'} element={<Page404 />} />
            <Route path={'/500_error'} element={<Page500 />} />
            <Route path={'/Applications/Telecommunications/*'} element={<TelecomunicationPage />} />
            <Route path={'/Applications/aerospace-defense-medical/*'} element={<AerospacePage />} />
            <Route path={'/About/Careers/*'} element={<CareerPage />} />
            <Route
                path={'/Applications/temp-sensing-for-electronics/*'}
                element={<ElectronicApplicationPage />}
            />
            <Route path={'/Applications/hvac/*'} element={<HVACPage />} />
            {/* KEMET Redirect routes */}
            <Route path="/obb/*" element={<Navigate to="/browse/products/" replace />} />
            <Route path="/:lan/us.html" element={<Navigate to="/" replace />} />
            <Route path="/tools/*" element={<Navigate to="/browse/products/" replace />} />
            <Route path="/sales" element={<Navigate to="/SalesResources/SalesOffices" replace />} />
            <Route path="/wp-content/*" element={<Navigate to="/" replace />} />
            <Route
                path="/en/us/applications/automotive.html"
                element={<Navigate to="/applications/automotive" replace />}
            />
            <Route
                path="/en/us/applications/computing.html"
                element={<Navigate to="/applications/computing-enterprisesystems" replace />}
            />
            <Route
                path="/en/us/applications/consumer.html"
                element={<Navigate to="/applications/consumer" replace />}
            />
            <Route
                path="/en/us/applications/defense-and-aerospace.html"
                element={<Navigate to="/applications/aerospace-defense-medical/Overview" replace />}
            />
            <Route
                path="/en/us/applications/industrial.html"
                element={<Navigate to="/applications/industrial" replace />}
            />
            <Route
                path="/en/us/applications/medical.html"
                element={<Navigate to="/applications/aerospace-defense-medical/Overview" replace />}
            />
            <Route
                path="/en/us/applications/telecommunications.html"
                element={<Navigate to="/applications/telecommunications/Overview" replace />}
            />
            <Route
                path="/en/us/capacitors/ceramic/product/:partNumber.html"
                element={<ProductRedirect />}
            />
            <Route
                path="/en/us/design-analysis-tools.html"
                element={
                    <Navigate to="/SalesResources/SimulationTools/Overview/Overview" replace />
                }
            />
            <Route
                path="/en/us/fit-calculator.html"
                element={
                    <Navigate to="/SalesResources/SimulationTools/Overview/Overview" replace />
                }
            />
            <Route path="/en/us/search.html" element={<SearchRedirect />} />
            <Route path="/53142/2019-02-15/k4nccp" element={<Navigate to="/" replace />} />
            <Route path="/Lists/Filestore/*" element={<SearchRedirectFiles />} />
            {/* NEXENSOS Redirect routes */}
            <Route
                path="/:lan/about-yageo-nexensos/jobs.html"
                element={<Navigate to="/About/Careers/Innovate%20with%20Us" replace />}
            />
            <Route
                path="/:lan/sensors/sensor-ceramic-housing.html"
                element={<Navigate to="/products/Sensors%20-%20Temperature?79=1150" replace />}
            />
            <Route
                path="/:lan/sensors/wired-sensors/cryo-temperature-range.html"
                element={<Navigate to="/products/Sensors%20-%20Temperature?79=1156" replace />}
            />
            <Route
                path="/:lan/sensors/wired-sensors/high-temperature-range.html"
                element={<Navigate to="/products/Sensors%20-%20Temperature?79=1156" replace />}
            />
            <Route
                path="/:lan/sensors/wired-sensors/low-temperature-range.html"
                element={<Navigate to="/products/Sensors%20-%20Temperature?79=1156" replace />}
            />
            <Route
                path="/:lan/sensors/wired-sensors/medium-temperature-range.html"
                element={<Navigate to="/products/Sensors%20-%20Temperature?79=1156" replace />}
            />
            <Route
                path="/:lan/sensors/wired-sensors.html"
                element={<Navigate to="/products/Sensors%20-%20Temperature?79=1156" replace />}
            />
            <Route
                path="/:lan/sensors/smd.html"
                element={<Navigate to="/products/Sensors%20-%20Temperature?79=1168" replace />}
            />
            <Route
                path="/:lan/sensors/sot-to.html"
                element={<Navigate to="/products/Sensors%20-%20Temperature?79=1171" replace />}
            />
            <Route
                path="/:lan/sensors/sinterable-temperature-sensor.html"
                element={<Navigate to="/products/Sensors%20-%20Temperature?79=1174" replace />}
            />
            <Route
                path="/:lan/sensors/sensor-assemblies/rt-series.html"
                element={<Navigate to="/products/Sensors%20-%20Temperature?79=1177" replace />}
            />
            <Route
                path="/:lan/sensors/sensor-assemblies.html"
                element={<Navigate to="/products/Sensors%20-%20Temperature?79=1177" replace />}
            />
            <Route
                path="/:lan/sensors/sensor-assemblies/th-series.html"
                element={<Navigate to="/products/Sensors%20-%20Temperature?79=1177" replace />}
            />
            <Route
                path="/:lan/sensors/sensor-assemblies/we-series.html"
                element={<Navigate to="/products/Sensors%20-%20Temperature?79=1177" replace />}
            />
            <Route
                path="/:lan/contact.html"
                element={<Navigate to="/SalesResources/ContactUs" replace />}
            />
            <Route
                path="/:lan/contact/sites.html"
                element={<Navigate to="/SalesResources/ContactUs" replace />}
            />
            <Route
                path="/:lan/press-and-news-sensors/122020-vaccine-distribution-increases-demand.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/16639" replace />}
            />
            <Route
                path="/:lan/press-and-news-sensors/122020-vaccine-distribution-increases-demand.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/16639" replace />}
            />
            <Route
                path="/:lan/technical-sensor-academy.html"
                element={<Navigate to="/SalesResources/SensorAcademy" replace />}
            />
            <Route
                path="/:lan/temperature-experts.html"
                element={<Navigate to="/SalesResources/SensorAcademy" replace />}
            />
            <Route
                path="/:lan/webinar.html"
                element={<Navigate to="/SalesResources/SensorAcademy" replace />}
            />
            <Route
                path="/:lan/press-and-news-sensors.html"
                element={<Navigate to="/About/Newsroom" replace />}
            />
            <Route
                path="/:lan/press-and-news-sensors/yageo-signs-agreement.html"
                element={<Navigate to="/About/Newsroom" replace />}
            />
            <Route
                path="/:lan/about-yageo-nexensos.html"
                element={<Navigate to="/About/YAGEOGroupOverview" replace />}
            />
            <Route
                path="/:lan/sensors.html"
                element={<Navigate to="/browse/products/Sensors%20-%20Temperature" replace />}
            />
            <Route
                path="/:lan/sensors/pcb.html"
                element={<Navigate to="/products/Sensors%20-%20Temperature?79=1153" replace />}
            />
            <Route
                path="/:lan/sensors/sensor-assemblies/ce-series.html"
                element={<Navigate to="/products/Sensors%20-%20Temperature?79=1177" replace />}
            />
            <Route
                path="/:lan/sensors/sensor-assemblies/ec-series.html"
                element={<Navigate to="/products/Sensors%20-%20Temperature?79=1177" replace />}
            />
            <Route
                path="/:lan/sensors/sensor-assemblies/mt-series.html"
                element={<Navigate to="/products/Sensors%20-%20Temperature?79=1177" replace />}
            />
            <Route
                path="/:lan/sensors/sensor-assemblies/py-series.html"
                element={<Navigate to="/products/Sensors%20-%20Temperature?79=1177" replace />}
            />
            <Route
                path="/:lan/sensors/heater.html"
                element={<Navigate to="/products/Sensors%20-%20Temperature?79=1180" replace />}
            />
            <Route
                path="/:lan/press-and-news-sensors/2023-04-closing-yageo.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/16631" replace />}
            />
            <Route
                path="/:lan/press-and-news-sensors/2022-06-accensors.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/16640" replace />}
            />
            <Route
                path="/:lan/press-and-news-sensors/2022-06-accensors.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/16640" replace />}
            />
            <Route
                path="/:lan/press-and-news-sensors/2023-11-m222-pb-free.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/16642" replace />}
            />
            <Route
                path="/:lan/press-and-news-sensors/50-years-pt-sensors.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/16673" replace />}
            />
            <Route
                path="/:lan/press-and-news-sensors/50-years-pt-sensors.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/16673" replace />}
            />
            <Route
                path="/:lan/press-and-news-sensors/flexible-sensor.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/16676" replace />}
            />
            <Route
                path="/:lan/press-and-news-sensors/johor-iatf-certification.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/16677" replace />}
            />
            <Route
                path="/:lan/press-and-news-sensors/johor-iatf-certification.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/16677" replace />}
            />
            <Route
                path="/:lan/applications/hvac.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17022" replace />}
            />
            <Route
                path="/:lan/applications/hvac/pcb-advantages-hvac.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17022" replace />}
            />
            <Route
                path="/:lan/applications/hvac/smd-advantages-hvac.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17022" replace />}
            />
            <Route
                path="/:lan/applications/process-technology-sensors.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17040" replace />}
            />
            <Route
                path="/:lan/applications/health.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17041" replace />}
            />
            <Route
                path="/:lan/applications/emobility.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17042" replace />}
            />
            <Route
                path="/:lan/applications/mobility.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17042" replace />}
            />
            <Route
                path="/:lan/applications/energy.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17044" replace />}
            />
            <Route
                path="/:lan/applications/exhaust-gas-treatment.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17047" replace />}
            />
            <Route
                path="/:lan/applications/life-science-sensors.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17053" replace />}
            />
            <Route
                path="/:lan/applications/household.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17054" replace />}
            />
            <Route
                path="/:lan/applications/artificial-intelligence.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17060" replace />}
            />
            <Route
                path="/:lan/technical-sensor-academy/packaging-options.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17063" replace />}
            />
            <Route
                path="/:lan/webinar/emobility-video.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17065" replace />}
            />
            <Route
                path="/:lan/webinar/growing-requirements.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17066" replace />}
            />
            <Route
                path="/:lan/webinar/installation-impact-on-performance.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17066" replace />}
            />
            <Route
                path="/:lan/webinar/products-applications-video.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17070" replace />}
            />
            <Route
                path="/:lan/webinar/sensor-assemblies-video.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17071" replace />}
            />
            <Route
                path="/:lan/webinar/technical-comparison-video.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17072" replace />}
            />
            <Route
                path="/:lan/webinar/technical-training-pt-rtd.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17073" replace />}
            />
            <Route
                path="/:lan/technical-sensor-academy/pt-sensors-in-general.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17074" replace />}
            />
            <Route
                path="/:lan/technical-sensor-academy/pt-ntc-comparison.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17078" replace />}
            />
            <Route
                path="/:lan/technical-sensor-academy/technical-introduction.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17079" replace />}
            />
            <Route
                path="/:lan/technical-sensor-academy/tolerances.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17080" replace />}
            />
            <Route
                path="/:lan/technical-sensor-academy/physical-characteristics.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17081" replace />}
            />
            <Route
                path="/:lan/technical-sensor-academy/assembly-considerations.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17082" replace />}
            />
            <Route
                path="/:lan/technical-sensor-academy/specification.html"
                element={<Navigate to="/SalesResources/ResourceLibrary/item/17083" replace />}
            />
            <Route
                path="/:lan/sensing-success-stories.html"
                element={<Navigate to="/SalesResources/SensorAcademy" replace />}
            />
            <Route
                path="/:lan/registration.html"
                element={
                    <Navigate
                        to="https://yageogroup.online/newsletter/?utm_source=YG-footer&utm_medium=YG-website&utm_campaign=YG-footer-website&utm_id=Newsletter"
                        replace
                    />
                }
            />
        </Routes>
    );
}

export default App;
